module.exports = __webpack_public_path__ + "static/media/Etape3-Rencontre-Option-n3.11ef5dab.png";